import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { useDeleteJobPositionMutation } from 'store/api/jobPositions';
import { t } from 'utils/getTranslations';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState';

/**
 * Opens the job position's delete confirmation; once deleted, `onDeleted` runs and the page leaves the record. The
 * edit form and the record header both offer it.
 */
export const useDeleteJobPosition = (jobPositionId: string | undefined, onDeleted?: () => void) => {
    const { openModal, closeModal } = useModal();
    const [deleteJobPosition] = useDeleteJobPositionMutation();
    const leaveDeleted = useLeaveDeletedEntity('/job-positions');

    return () => {
        if (!jobPositionId || isNaN(Number(jobPositionId))) {
            return;
        }
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    void deleteJobPosition({ id: jobPositionId })
                        .unwrap()
                        .then(() => {
                            onDeleted?.();
                            leaveDeleted();
                        })
                        .catch(console.error)
                        .finally(() => closeModal());
                }}
                content={t('job-positions.delete-confirmation-text')}
            />
        );
    };
};
